import React from 'react'

export function MoreOptionsButton() {
    return (
        <div>
            <div
                className="dx-link customCellTemplate"
                title="More Options"
                onClick={onMoreOptionsClicked}
                key={Math.random()}
            />
        </div>
    )
}

function onMoreOptionsClicked(e) {
    const dxContextMenuEvent = new MouseEvent('dxcontextmenu', e.nativeEvent)
    e.currentTarget.dispatchEvent(dxContextMenuEvent)
}

export function ContextMenuTemplate(props) {
    let srcText = `/svg/${props["icon"]}.svg`;
    //className="action-item"
    return (<div style={{minWidth: "150px", display: "flex", alignItems: "center"}}>
        <img src={srcText} alt="eye" style={{marginRight: "10px", width: "16px", height: "16px"}}/>
        {props["text"]}
    </div>)
}